import { Row, Col, Button } from 'antd'
import '../App.css'
import Logo from '../Assets/logo.png'

export default function Navbar({ navigate }) {
  return (
    <Row gutter={16}>
      <nav className="nav pt-2 py-md-2 px-md-3">
        {/* Brand */}
        <Col
          xs={24}
          md={18}
          className="d-flex align-items-center justify-content-start"
        >
          <div className="nav-brand">
            <div>
              <img src={Logo} alt="Logo" className="brand-ring" />
            </div>
            <div className='brand-name'>
              <p className='b-name'>THE ROTARY SILVER JUBILEE TRUST, SWIMMING POOL, SANGLI.</p>
              <p className='text-center'>
                {/* SWIMMING POOL, SANGLI */}
              </p>
            </div>
          </div>
        </Col>

        {/* Admin Button */}
        <Col
          xs={24}
          md={6}
          className="d-flex align-items-center justify-content-end mt-2 mt-md-0"
        >
          <Button
            className="nav-admin-btn d-none d-lg-flex"
            type="primary"
            onClick={() => navigate('/admin-login')}
          >
            Admin Login
          </Button>
        </Col>
      </nav>
    </Row>
  )
}
